module.exports = __webpack_public_path__ + "img/cart--pink-circle.b9597b96.svg";